import { dialog } from "nq-component";

class ForgotPresenter {
  constructor(view, resetPassword) {
    this.view = view;
    this.resetPassword = resetPassword;
  }

  forgotPassword(email) {
    const value = (email || "").trim();
    if (!value) {
      this.view.showError("Enter your email or username.");
      return;
    }

    this.view.setState({ circular: true });
    this.view.showProgress();
    this.resetPassword
      .execute(value, { timeout: 0 })
      .then((response) => {
        this.view.hideProgress();
        this.view.setState({ circular: false });
        if (!response) {
          this.view.showError(
            "An error occurred while resetting the password.",
          );
          return;
        }

        dialog.fire({
          html: (
            <div className="m-3">
              <div className="text-center">
                <p>A link has been sent to your email</p>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  type="button"
                  className="btn text-white"
                  onClick={() => {
                    dialog.close();
                    this.view.navigateTo("/signin");
                  }}
                  style={{ backgroundColor: "#29457c" }}
                >
                  OKAY
                </button>
              </div>
            </div>
          ),
          footer: false,
        });
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.setState({ circular: false });
        this.view.showError(
          error.message || "An error occurred while resetting the password.",
        );
      });
  }
}

export default ForgotPresenter;
